

export const env:any = {
  development:{
    base_url : 'https://jobito.app'
  }
}